module.exports = {
	"classes": [
		"media-publishing-page",
		"header-dark"
	],
	"title": "Media & Publishing",
	"metas": {
		"description": "Thinking of using first-party data to deliver personalized experiences to the digital subscriber? Leverage Auth0's CIAM capabilities to optimize registration conversions and build a single view across all your media properties to personalize content and ads."
	},
	"opengraph": {
		"og:title": "Media & Publishing",
		"og:description": "Thinking of using first-party data to deliver personalized experiences to the digital subscriber? Leverage Auth0's CIAM capabilities to optimize registration conversions and build a single view across all your media properties to personalize content and ads.",
		"og:url": "https://auth0.com/media-publishing",
		"og:image": "https://cdn.auth0.com/website/media-publishing/images/media-publishing-twitter-card.png",
		"og:image:secure_url": "https://cdn.auth0.com/website/media-publishing/images/media-publishing-twitter-card.png"
	},
	"twittercard": {
		"twitter:title": "Media & Publishing",
		"twitter:description": "Thinking of using first-party data to deliver personalized experiences to the digital subscriber? Leverage Auth0's CIAM capabilities to optimize registration conversions and build a single view across all your media properties to personalize content and ads.",
		"twitter:image": [
			{
				"src": "https://cdn.auth0.com/website/media-publishing/images/media-publishing-twitter-card.png"
			}
		]
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/pages/media-publishing/metadata.json
// module id = 1422
// module chunks = 0